import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import MainLayout from "./layouts/MainLayout";
import RequireAuth from "./components/RequireAuth";
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import OfferPage from "./pages/OfferPage";
import ContactPage from "./pages/ContactPage";
import CartPage from "./pages/CartPage";
import ProductDetailPage from "./pages/ProductDetailPage";
import AddProductPage from "./pages/AddProductPage";
import LoginPage from "./pages/LoginPage";
import CheckoutPage from "./pages/CheckoutPage";
import CustomerFormPage from "./pages/CustomerFormPage";
import ConfirmPage from "./pages/ConfirmPage";
import ThankYouPage from "./pages/ThankYouPage";
import UpdateProductPage from "./pages/UpdateProductPage";
import {DemoPage} from "./pages/DemoPage";
import ProductsTablePage from "./pages/ProductsTablePage";

function App() {
    return (
        <BrowserRouter>
            <MainLayout>
                <Routes>
                    <Route path="/" element={<HomePage />} />
                    <Route path="/o-nas" element={<AboutPage />} />
                    <Route path="/ponuka" element={<OfferPage />} />
                    <Route path="/kontakt" element={<ContactPage />} />
                    <Route path="/kosik" element={<CartPage />} />
                    {/*<Route path="/produkt/:id" element={<ProductDetailPage />} />*/}
                    <Route path="/produkt/:slug" element={<ProductDetailPage />} />
                    <Route path="/produkt/novy"
                        element={
                            <RequireAuth>
                                <AddProductPage />
                            </RequireAuth>
                        }
                    />
                    <Route path="/login" element={<LoginPage />} />
                    <Route path="/objednavka" element={<CheckoutPage />} />
                    <Route path="/udaje" element={<CustomerFormPage />} />
                    <Route path="/zhrnutie" element={<ConfirmPage />} />
                    <Route path="/dakujeme" element={<ThankYouPage />} />
                    <Route path="/demo" element={<DemoPage />} />
                    <Route path="/admin/produkt/:id/upravit" element={<UpdateProductPage />} />
                    <Route path="/admin/produkty"
                           element={
                                <RequireAuth>
                                    <ProductsTablePage/>
                                </RequireAuth>
                           }
                    />
                    <Route path="*" element={<Navigate to="/" replace />} />

                </Routes>
            </MainLayout>
        </BrowserRouter>
    );
}

export default App;
